import { WifiOff } from 'lucide-react';
import { Navigate, Outlet, useLocation } from 'react-router';
import { Button } from '../components/Button';
import { EmptyState } from '../components/EmptyState';
import { LoadingScreen } from '../components/Loading';
import { errorMessage } from '../lib/api';
import { useMe } from './useAuth';

export const CHANGE_PASSWORD_PATH = '/zmiana-hasla';

/** Routes below need a signed-in user; a temporary password must be replaced first. */
export function RequireAuth() {
  const me = useMe();
  const location = useLocation();

  if (me.isPending) return <LoadingScreen />;
  if (me.isError) {
    return (
      <div style={{ padding: 'var(--space-4)' }}>
        <EmptyState
          icon={WifiOff}
          title="Nie można otworzyć aplikacji"
          action={
            <Button variant="primary" onClick={() => void me.refetch()}>
              Spróbuj ponownie
            </Button>
          }
        >
          {errorMessage(me.error)}
        </EmptyState>
      </div>
    );
  }

  const user = me.data.user;
  if (!user) {
    const next = location.pathname + location.search;
    const target = next === '/' || next.startsWith('/logowanie') ? '/logowanie' : `/logowanie?next=${encodeURIComponent(next)}`;
    return <Navigate to={target} replace />;
  }
  if (user.mustChangePassword && location.pathname !== CHANGE_PASSWORD_PATH) {
    return <Navigate to={CHANGE_PASSWORD_PATH} replace />;
  }
  if (!user.mustChangePassword && location.pathname === CHANGE_PASSWORD_PATH) {
    return <Navigate to="/kalendarz" replace />;
  }
  return <Outlet />;
}

/** Manager-only screens; workers see an explanation instead of a broken page. */
export function RequireAdmin() {
  const { data } = useMe();
  if (data?.user?.role !== 'admin') {
    return <Navigate to="/brak-dostepu" replace />;
  }
  return <Outlet />;
}

/** Only allow same-app paths as a post-login destination. */
export function safeNext(next: string | null): string {
  if (!next || !next.startsWith('/') || next.startsWith('//')) return '/kalendarz';
  return next;
}
